import { render, staticRenderFns } from "./CollectionDetails.vue?vue&type=template&id=5dbec4d7&scoped=true&"
import script from "./CollectionDetails.vue?vue&type=script&lang=js&"
export * from "./CollectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetails.vue?vue&type=style&index=0&id=5dbec4d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbec4d7",
  null
  
)

export default component.exports